import React, { Fragment } from 'react'
import ReactSelect from 'react-select'
import { pxToRem, color } from '../../utils'

var customStyles = {
  control: (base, state) => ({
    ...base,
    border: '1px solid #d8d8d8',
    background: 'none',
    borderRadius: '0',
    textTransform: 'uppercase',
    fontFamily: `'Open Sans', sans-serif`,
    padding: `${pxToRem('2px')}`,
    height: `${pxToRem('36px')}`
  }),
  singleValue: (base, state) => ({
    ...base,
    textTransform: 'uppercase',
    color: color.secondary
  }),
  option: (base, state) => {
    const styles = {
      ...base,
      fontFamily: `'Open Sans', sans-serif`,
      textTransform: 'uppercase'
    }

    if (state.isFocused && !state.isSelected) {
      styles.background = '#f4f7f9'
    } else if (state.isSelected) {
      styles.background = color.secondary
    }

    return styles
  },
  indicatorSeparator: (base, state) => ({
    ...base,
    display: 'none'
  }),
  menu: (base, state) => ({
    ...base,
    borderRadius: '0',
    margin: '0'
  }),
  menuList: (base, state) => ({
    ...base,
    margin: '0',
    padding: '0',
    fontSize: `${pxToRem(12)}`
  }),
  noOptionsMessage: (base, state) => ({
    ...base,
    fontFamily: `'Open Sans', sans-serif`
  }),
  placeholder: (base, state) => ({
    ...base,
    fontSize: `${pxToRem(12)}`
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    padding: pxToRem(2)
  })
}

const Select = props => {
  const { options = [], placeholder = 'SELECIONE', withPortal = false, ...rest } = props
  if (withPortal) customStyles = { ...customStyles, menuPortal: (base) => ({ ...base, zIndex: 9999 }) }

  return (
    <Fragment>
      <ReactSelect
        {...rest}
        options={options}
        placeholder={placeholder}
        styles={customStyles}
        noOptionsMessage={() => {
          return 'Nenhuma opção para esta busca'
        }}
        menuPortalTarget={withPortal && document.body}
      />
    </Fragment>
  )
}

export default Select



// WEBPACK FOOTER //
// ./src/components/Form/Select.js